// extracted by mini-css-extract-plugin
export default {"sidebarMenu":"Sidebar_sidebarMenu__ZMjQ9","active":"Sidebar_active__8Oyl9"};